// EmailJS Configuration
export const EMAIL_JS_CONFIG = {
  service: import.meta.env.VITE_EMAILJS_SERVICE_ID || "service_kyiywhe",
  template: import.meta.env.VITE_EMAILJS_TEMPLATE_ID || "template_aij7j29",
  publicToken: import.meta.env.VITE_EMAILJS_PUBLIC_KEY || "pWfjS0wJ7dP1XCsMb",
  to_email:
    import.meta.env.VITE_EMAILJS_TO_EMAIL || "comunicaciones@penadefillo.com",
};
